class FindationButton extends HHBaseElement {
  latestResults = {}

  constructor() {
    super()
    this._handlePostMessage = this._handlePostMessage.bind(this)
    this._handleClick = this._handleClick.bind(this)
    this.$button = this.querySelector('button')
    if (!this.isQuickShop) {
      this._injectTaget()
      this._initScript()
      this.$button.disabled = 'true'
    }
    this._isReady = false
  }

  connectedCallback() {
    if (this.isQuickShop) {
      this._attachListeners()
    }
  }

  disconnectedCallback() {
    this._removeListeners()
  }

  widgetEmbedded() {
    this._isReady = true
    this.$button.removeAttribute('disabled')
    let iframe = document.getElementById('findation-button-iframe')
    iframe.setAttribute('aria-hidden', 'true')
    iframe.classList.add('hidden')
    this._attachListeners()
    // 'Presented' is the default state
  }

  widgetDidOpen() {
    // Opened
    document.querySelector('html').classList.add('frozen')
    document.querySelector('body').classList.add('frozen')
  }

  widgetDidClose(event) {
    // Closed
    document.querySelector('html').classList.remove('frozen')
    document.querySelector('body').classList.remove('frozen')
    document.getElementById('findation-iframe').src += ''
  }

  onSearchComplete(data) {
    this.latestResults = {
      ...data,
    }
    if (data.matchSuccess) {
      crdl('event', 'findation_match_found', this.latestResults)
    } else {
      crdl('event', 'findation_no_match_found', this.latestResults)
    }
  }

  get apiKey() {
    return this.getAttribute('api-key')
  }

  get mode() {
    return this.getAttribute('mode') === 'true'
  }

  get isQuickShop() {
    return this.getAttribute('quick-shop') === 'true'
  }

  get productUrl() {
    return this.getAttribute('data-url')
  }

  _injectTaget() {
    this.target = document.createElement('div')
    this.target.id = 'findation-widget-button'
    this.appendChild(this.target)
  }

  _initScript() {
    if (document.getElementById('findation-widget-script')) {
      this._initWidget()
    } else {
      const script = document.createElement('script')
      script.type = 'text/javascript'
      script.async = true
      script.id = 'findation-widget-script'
      script.onload = () => {
        this._initWidget()
      }
      script.src = 'https://assets.findation.com/javascripts/w-adv-10.min.js'
      document.body.appendChild(script)
    }
  }

  _initWidget() {
    window.Findation = window.Findation || {}
    Findation.widgetEmbedded = this.widgetEmbedded.bind(this)
    Findation.widgetDidOpen = this.widgetDidOpen.bind(this)
    Findation.widgetDidClose = this.widgetDidClose.bind(this)
    Findation.onSearchComplete = this.onSearchComplete.bind(this)

    Findation.init(this.target, this.apiKey, {
      isDemoMode: this.mode,
    })

    window.addEventListener('message', this._handlePostMessage)

    if (location.hash === '#find-my-shade') {
      this._handleClick()
    }
  }

  set _isReady(value) {
    this.$button.disabled = !value
    this.$button.style.cursor = value ? 'pointer' : 'not-allowed'
    this.$button.style.opacity = value ? 1 : 0.5
  }

  _handlePostMessage(event) {
    if (!event.origin?.includes('findation.com')) return
    if (
      event.data?.eventName === 'shareFindationResults' &&
      event.data?.email
    ) {
      this._handleShareResults(event.data?.email)
    }
  }

  _handleShareResults(email) {
    if (!this.latestResults) return
    for (const key in this.latestResults) {
      this.setAttribute(`data-${key}`, JSON.stringify(this.latestResults[key]))
    }
    this._sendToCordial(email)
  }

  get _dataForCordial() {
    return {
      'Product Name': this.getAttribute('product-name'),
      'Product Shade': this.latestResults?.recommendedShade,
      'Product SKU': this.latestResults?.externalId,
      ...this.latestResults,
    }
  }

  _sendToCordial(email) {
    try {
      crdl(
        'contact',
        { email },
        {
          opt_in_source: 'findation_shade_match',
          channels: { email: { subscribeStatus: 'subscribed' } },
          recommendedShade: this.latestResults?.recommendedShade,
        }
      )
      crdl('event', 'findation_shade_match_shared', this._dataForCordial)
      console.log('Sent to cordial', {
        email,
        ...this._dataForCordial,
      })
    } catch (error) {
      console.log(error)
    }
  }

  _handleClick() {
    if (this.isQuickShop) {
      location.href = this.productUrl
    } else {
      window.postMessage('overlayOpen')
    }
  }

  _attachListeners() {
    this.$button.addEventListener('click', this._handleClick)
  }

  _removeListeners() {
    window.removeEventListener('message', this._handlePostMessage)
    this.$button.removeEventListener('click', this._handleClick)
  }
}

window.customElements.define('findation-button', FindationButton)
